import { LangText } from '@/components'
import num01 from '@/assets/svg/num_01.svg'
import num02 from '@/assets/svg/num_02.svg'
import num03 from '@/assets/svg/num_03.svg'
import { preFixImgUrl } from '@/utils'

const SERVICE_BACKGROUND =
  '7d312a55718759984b02b77675a8b998.png'

const SERVICE_ITEMS = [
  {
    numberImage: num01,
    phoneImage: 'f9d491ad66b794b72465619b6ade0344.png',
    titleKey: 'coupon.services.items.drugstoreElectronics.title',
  },
  {
    numberImage: num02,
    phoneImage: '007c12a1aad907d7adf6cd00b9d8c6cd.png',
    titleKey: 'coupon.services.items.departmentStores.title',
  },
  {
    numberImage: num03,
    phoneImage: '9caf222373e76ebfaded079ad23dae29.png',
    titleKey: 'coupon.services.items.fashion.title',
  },
] as const

const ServiceContent = () => (
  <section
    className="overflow-hidden w-full bg-center bg-no-repeat bg-cover rounded-[80px_0_0_0]"
    style={{ height: 974, backgroundImage: `url(${preFixImgUrl(SERVICE_BACKGROUND)})` }}
  >
    <div className="mx-auto flex h-full w-[1200px] flex-col items-center pt-[60px]">
      <div className="flex flex-col items-center">
        <LangText
          lngKey="coupon.services.title"
          className="text-[36px] font-bold leading-[50px] text-white"
        />
        <span className="mt-[20px] h-[4px] w-[104px] rounded-full bg-white/20" />
      </div>

      <div className="mt-[24px] grid w-full grid-cols-3 gap-[40px] px-[60px]">
        {SERVICE_ITEMS.map((item) => (
          <article key={item.titleKey} className="flex flex-col items-center min-w-0">
            <div className="flex h-[60px] items-center justify-center">
              <img
                src={item.numberImage}
                alt=""
                className="h-[62px] w-auto object-contain"
                aria-hidden
              />
            </div>
            <LangText
              lngKey={item.titleKey}
              className="mt-[-2px] font-smiley-sans text-[32px] font-medium leading-[38px] text-white"
            />
            <img
              src={preFixImgUrl(item.phoneImage)}
              alt=""
              className="mt-[12px] h-[634px] w-[313px] object-contain"
              draggable={false}
            />
          </article>
        ))}
      </div>
    </div>
  </section>
)

export default ServiceContent
